module.exports = __webpack_public_path__ + "static/img/page-loader.4fae74ca.svg";